import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { useIsAuthenticated } from "@azure/msal-react";
import Login from "./pages/Login";

function App() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <div className="app">
      <BrowserRouter>
        {isAuthenticated ? (
          <>
            <AppRoutes />
            <ToastContainer />
          </>
        ) : (
          <Login />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
